import styled, { css, keyframes } from 'styled-components'

import { cases } from '@subaio/utils'

import { type AnimationProps, AnimationStatus } from '../../useKeyedAnimation'
import type { Options } from './Options'

const animationIn = keyframes`
	0% {
		opacity: 0;
		transform: translateY(-20px) scale(0.9);
	}
`

const animationOut = keyframes`
	100% {
		opacity: 0;
		transform: translateY(20px) scale(1.1);
	}
`

export const Container = styled.div<AnimationProps & Options>`
	position: relative;
	pointer-events: auto;
	display: flex;
	flex-direction: column;
	gap: 16px;

	max-width: ${({ maxWidth = '800px' }) => maxWidth};
	padding: ${({ padding = '16px 8px' }) => padding};
	border: 8px solid ${({ backgroundColor }) => backgroundColor};
	border-radius: 8px;

	color: ${({ textColor }) => textColor};
	background-color: ${({ backgroundColor }) => backgroundColor};
	overflow-wrap: break-word;
	overflow: ${({ overflow = 'auto' }) => overflow};

	box-shadow: ${({ showShadow }) => (showShadow ? 'rgba(0, 0, 0, 0.2) 0px 5px 20px, rgba(0, 0, 0, 0.2) 0px 2px 5px' : undefined)};

	${({ status, duration }) =>
		cases(status, {
			[AnimationStatus.Entering]: css`
			animation: ${duration}s ${animationIn};
		`,
			[AnimationStatus.Exiting]: css`
			animation: ${duration}s ${animationOut} forwards;
		`,
		})}
`
